import { node } from "../util/dom";

/* eslint-disable */
const WindyWebcamMarker = function(coords, id, opts) {
	SMap.Marker.POI.call(this, coords, id, opts);
};

WindyWebcamMarker.prototype = Object.create(Object.assign({}, SMap.Marker.prototype, SMap.Marker.POI.prototype));

WindyWebcamMarker.prototype.setActive = function(state = false) {
	const elem: HTMLElement = this.getContainer()[SMap.LAYER_MARKER];

	elem.classList[state ? "add" : "remove"]("active-detail");
};

/**
 * Zakladni lookupy.
 */
WindyWebcamMarker.fromData = function(data: any) {
	const imgSrc = data.url || data.img || "";
	const width = 60;
	const height = width / (4 / 3) >>> 0;

	const coords = SMap.Coords.fromWGS84(data.mark.lon, data.mark.lat);
	const marker = new WindyWebcamMarker(coords, `${data.id}-${Math.random().toString(16).replace("0.", "")}`, {
		title: data.title,
		anchor: {
			top: height / 2,
			left: width / 2,
		},
		size: [width, height],
	});

	const elem: HTMLElement = marker.getContainer()[SMap.LAYER_MARKER];
	const placeholder = node("span", { className: "windy-webcam-placeholder" });
	const img = new Image();

	placeholder.dataset.imgSrc = imgSrc;
	img.crossOrigin = "anonymous";
	img.addEventListener("load", () => {
		placeholder.remove();
		elem.append(img);
	});
	elem.classList.add("windy-webcam-marker");
	elem.append(placeholder);

	if (imgSrc) {
		img.src = imgSrc;
	}

	return marker;
};

export { WindyWebcamMarker };
